import { useEffect } from 'react';
import { getAppName } from '@/lib/appName';

const APP_NAME = getAppName();

/**
 * Sets document.title to "<pageTitle> | {APP_NAME}".
 * Pass an empty string or undefined to show just "{APP_NAME}".
 * Resets to "{APP_NAME}" on unmount so stale titles never linger.
 */
export function usePageTitle(pageTitle?: string): void {
  useEffect(() => {
    document.title = pageTitle ? `${pageTitle} | ${APP_NAME}` : APP_NAME;
    return () => {
      document.title = APP_NAME;
    };
  }, [pageTitle]);
}
